/**
 * Returns a data URL of the thumbnailed image
 * @param {String} image
 * @param {Number} size max width and height
 * @returns {String} a data URL
 */
export async function thumbnail(image, size, ysize=null) {
    if (! ysize) {
        ysize = size;
    }
    let canvas = document.createElement("canvas");
    let retval = null;
    try {
        retval = await new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = resolveThumbnail({img, size, ysize, canvas, resolve, reject});
            img.src = image;
        });
    } catch(ex) {
        console.info(ex);
        retval = await new Promise((resolve, reject) => {
            let img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onload = resolveThumbnail({img, size, ysize, canvas, resolve, reject});
            img.src = image;
        });
    }
    return retval;
}

function resolveThumbnail({img, size, ysize, canvas, resolve, reject}) {
    return function() {
        let w = img.width;
        let h = img.height;
        if (w > size) {
            let ratio = h / w;
            w = size;
            h = w * ratio;
        }
        if (h > ysize) {
            let ratio = w / h;
            h = ysize;
            w = h * ratio;
        }
        canvas.width = w;
        canvas.height = h;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, w, h);
        try {
            let result = canvas.toDataURL("image/png", 3);
            resolve(result);
        } catch(ex) {
            reject(ex);
        }
    };
}
